import _ from 'lodash'
import { populateCatalog, doCsvUploadForCatalog, doCsvUploadForCatalogSkillTag, getCatalogs, deleteAllCatalogs } from '../api'

export const loadCatalog = ({ state, commit }, {uuid, loadDataFromServer}) => {
  if (loadDataFromServer || _.isEmpty(state.catalog)) {
    return populateCatalog(uuid).then((response) => {
      commit('LOAD_CATALOG', response)
      return response
    })
  } else {
    commit('LOAD_CATALOG', state.catalog)
    return state.catalog
  }
}

export const uploadCatalogCsvFile = ({ state, commit }, {institutionId, createdByUuid, folderId, fileData}) => {
  return doCsvUploadForCatalog(institutionId, createdByUuid, folderId, fileData).then(res => {
    return res
  })
}

export const uploadCatalogSkillTagCsvFile = ({ state, commit }, data) => {
  return doCsvUploadForCatalogSkillTag(data)
}

export const loadCatalogs = ({ state, commit }, {page, count, keyword}) => {
  return getCatalogs(page, count, keyword)
}

export const loadDeleteAllCatalogs = ({ state, commit }) => {
  return deleteAllCatalogs()
}



// WEBPACK FOOTER //
// ./src/app/catalog/vuex/actions.js